module.exports = __webpack_public_path__ + "static/media/2_3hong.64b66d46.png";